import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import moment from 'moment';
import { AbilityContext } from 'utils/permissions';

import SettingsOutlineIcon from 'mdi-react/SettingsOutlineIcon';
import { updateSchedule, getSchedules } from 'redux/actions/scheduleActions';
import ScheduleForm from './ScheduleForm';


class ScheduleUpdate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    updateSchedule: PropTypes.func.isRequired,
    getSchedules: PropTypes.func.isRequired,
    accountId: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
      account: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      days_to_send: PropTypes.arrayOf(PropTypes.string).isRequired,
      exclude_us_holidays: PropTypes.bool.isRequired,
      time_from: PropTypes.instanceOf(Date).isRequired,
      time_to: PropTypes.instanceOf(Date).isRequired,
      scheduleId: PropTypes.number.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async onSubmit(formData) {
    try {
      await this.props.updateSchedule(
        this.props.initialValues.scheduleId,
        {
          name: formData.name,
          account: this.props.accountId,
          monday: formData.days_to_send.includes('monday'),
          tuesday: formData.days_to_send.includes('tuesday'),
          wednesday: formData.days_to_send.includes('wednesday'),
          thursday: formData.days_to_send.includes('thursday'),
          friday: formData.days_to_send.includes('friday'),
          saturday: formData.days_to_send.includes('saturday'),
          sunday: formData.days_to_send.includes('sunday'),
          time_from: moment(formData.time_from).format('HH:mm:ss'),
          time_to: moment(formData.time_to).format('HH:mm:ss'),
          exclude_us_holidays: formData.exclude_us_holidays,
          excluded_dates: formData.excluded_dates,
          timezone: formData.timezone.value,
        },
      );
      await this.props.getSchedules({ account__id: this.props.accountId }, true);
      this.toggle();
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    const { initialValues: { account } } = this.props;
    const isScheduleEditable = this.context.can('edit', 'Default Schedule') || account;

    return (
      <div className={this.props.className}>
        <SettingsOutlineIcon
          onClick={isScheduleEditable ? this.toggle : null}
          className={
            isScheduleEditable ? 'svg--primary' : 'svg--not-primary'
          }
        />
        <Dialog open={this.state.isOpen} onBackdropClick={this.toggle} size="large">
          <DialogTitle disableTypography>Add Schedule</DialogTitle>
          <ScheduleForm
            toggleModal={this.toggle}
            onSubmit={data => this.onSubmit(data)}
            initialValues={this.props.initialValues}
          />
        </Dialog>
      </div>
    );
  }
}

ScheduleUpdate.contextType = AbilityContext;

export default compose(
  connect(
    null,
    { updateSchedule, getSchedules },
  ),
  withNamespaces('common'),
)(ScheduleUpdate);
